import {ModuleIconInterface} from "../module-icon.interface";

export class SvgIcon {
    [key: string]: string
}

export const SVGICONTHEME: SvgIcon = {
    'access-future-engineer': 'access-future-engineer',
    'accessorize': 'accessorize',
    'achievement': 'profil',
    'admin-role': 'admin-role',
    'allTypes': 'toustypes',
    'animal-controls__download': 'download_rounded',
    'archive': 'archiver',
    'arrow-forward-rounded-500': 'arrow_forward_rounded_500',
    'arrow_back': 'arrow_back',
    'arrow_diag': 'arrow_diag',
    'arrow_left': 'arrow_left',
    'arrow_left_alt_rounded': 'arrow_left_alt_rounded',
    'arrow_left_circle_outline': 'arrow_left_circle_outline',
    'arrow_right': 'arrow_right',
    'arrow_right_circle_outline': 'arrow_right_circle_outline',
    'article_rounded': 'article_rounded',
    'article_rounded_fill': 'article_rounded_fill',
    'assign': 'assignation',
    'assignation': 'assignation',
    'assignment_ind': 'assignment_ind',
    'assignment_ind_fill': 'assignment_ind_fill',
    'automation_fill': 'automation_fill',
    'avatar': 'avatar',
    'award': 'award',
    'back': 'keyboard_arrow_up',
    'bar_chart': 'bar_chart',
    'bd-card__menu': 'more_horiz',
    'book': 'book',
    'brand': 'brand',
    'brand_menu': 'brand_menu',
    'brand_menu_large': 'brand_menu_large',
    'brand_square-en': 'brand-square-en',
    'brand_square-fr': 'brand-square-fr',
    'brand_square-nl': 'brand-square-nl',
    'brand_square_user-info': 'brand-square-user-info',
    'button-help__support': 'help_fill',
    'card-actions__icon-menu-trigger': 'keyboard_arrow_up',
    'check-circle-rounded_fill': 'check_circle_rounded_fill',
    'check-rounded': 'check_rounded',
    'check-rounded-700': 'check_rounded_700',
    'chevron': 'chevron_down_circle',
    'chevron-down-circle': 'chevron_down_circle',
    'class_add': 'add',
    'close': 'cross',
    'construction': 'construction',
    'contact': 'contact',
    'contact-us': 'contact-us',
    'conversion-path': 'conversion_path',
    'credits': 'coin',
    'cross': 'cross',
    'cross_outline': 'cross_outline',
    'cursor': 'cursor',
    'delete': 'trash',
    'diamond': 'diamond',
    'diversity-outlined-fill': 'diversity_3_outlined_fill',
    'document': 'document',
    'download-pdf': 'text_file',
    'drag_indicator': 'arrow_down_circle_outline',
    'duplicate': 'duplicate',
    'edit': 'edit',
    'editor-play': 'play_outline',
    'educ-role': 'educ-role',
    'educ-role-without-rec': 'educ-role-without-rec',
    'event-available': 'event_available',
    'event-upcoming': 'event_upcoming',
    'exit': 'exit',
    'faq-block__expand': 'chevron_down_circle',
    'feedback-dialog-by-steps__dissatisfied': 'sentiment_dissatisfied',
    'feedback-dialog-by-steps__satisfied': 'sentiment_satisfied',
    'feedback-dialog-by-steps__very-dissatisfied': 'sentiment_very_dissatisfied',
    'feedback-dialog-by-steps__very-satisfied': 'sentiment_very_satisfied',
    'file': 'corpus',
    'file_download': 'text_file',
    'fill-in-blanks': 'remplir_blancs',
    'folder': 'folder',
    'gamecode-card__menu': 'more_horiz',
    'graphic_eq_rounded': 'graphic_eq_rounded',
    'grid_view_rounded_fill': 'grid_view_rounded_fill',
    'group-outlined-fill': 'group_outlined_fill',
    'groups-form-add': 'check',
    'home': 'book',
    'iackathon-deliverable-list-page__expand': 'open_in_full_rounded',
    'iackathon-preview-zoom-dialog__close': 'close_rounded',
    'icon-arrow-back': 'arrow_back',
    'idea': 'wb_incandescent_rounded',
    'info_fill': 'info_fill',
    'information': 'information',
    'institution_add': 'add',
    'join': 'join',
    'key_vertical_fill': 'key_vertical_fill',
    'language': 'language',
    'leaderboard': 'leaderboard',
    'lesson-view__back': 'arrow_back_rounded',
    'lesson-view__breadcrumb-separator': 'arrow_forward_ios_rounded',
    'lesson-view__infobox': 'info_fill',
    'lesson-view__pdf-file': 'picture_as_pdf_rounded_fill',
    'lessons': 'transition',
    'link': 'url',
    'lock': 'padlock',
    'lock-rounded-fill': 'lock_rounded_fill',
    'logo_CTZC_college':'logo_CTZC_college',
    'logo_CTZC_iakathon':'logo_CTZC_iakathon',
    'logo_CTZC_junior':'logo_CTZC_junior',
    'logo_CTZC_python':'logo_CTZC_python',
    'mail': 'mail',
    'menu': 'menu_rounded',
    'mic_rounded_fill': 'mic_rounded_fill',
    'mindmap-card__menu': 'more_horiz',
    'navigation__for-further': 'brush',
    'next': 'next',
    'notepad-card__menu': 'more_horiz',
    'notif-list__assignment': 'assignation',
    'notif-list__notification': 'notifications_rounded',
    'notif-list__open': 'open_in_new',
    'notification__close': 'close_rounded',
    'notifications': 'notifications_rounded',
    'onboarding_header': 'onboarding_header',
    'open_in_new': 'open_in_new',
    'package': 'package',
    'pdf': 'ressources',
    'pdf_file_custom': 'pdf_file_custom',
    'person-outlined-fill': 'person_outlined_fill',
    'play': 'arrow_right',
    'play-as-icon': 'play_arrow_rounded_fill_custom',
    'play-in-class': 'play',
    'play-preview': 'play_arrow_rounded_fill_custom',
    'play-rounded-fill': 'play_arrow_rounded_fill_custom',
    'play_arrow_rounded_fill': 'play_arrow_rounded_fill',
    'play_circle_rounded_fill': 'play_circle_rounded_fill',
    'plus': 'plus',
    'polygon-3': 'polygon_3',
    'register': 'input',
    'round-videoprojeter': 'round_videoprojeter',
    'round-videoprojeteroff': 'round_videoprojeteroff',
    'save': 'save',
    'sdg_theme_clean_energy': 'sdg_theme_clean_energy',
    'sdg_theme_clean_water': 'sdg_theme_clean_water',
    'sdg_theme_climate_action': 'sdg_theme_climate_action',
    'sdg_theme_economic_growth': 'sdg_theme_economic_growth',
    'sdg_theme_education': 'sdg_theme_education',
    'sdg_theme_gender_equality': 'sdg_theme_gender_equality',
    'sdg_theme_health': 'sdg_theme_health',
    'sdg_theme_industry': 'sdg_theme_industry',
    'sdg_theme_life_below_water': 'sdg_theme_life_below_water',
    'sdg_theme_life_on_land': 'sdg_theme_life_on_land',
    'sdg_theme_no_poverty': 'sdg_theme_no_poverty',
    'sdg_theme_partnerships': 'sdg_theme_partnerships',
    'sdg_theme_peace_justice': 'sdg_theme_peace_justice',
    'sdg_theme_reduced_inequalities': 'sdg_theme_reduced_inequalities',
    'sdg_theme_resposible_consumption': 'sdg_theme_resposible_consumption',
    'sdg_theme_sustainable_cities': 'sdg_theme_sustainable_cities',
    'sdg_theme_zero_hunger': 'sdg_theme_zero_hunger',
    'shield': 'confi',
    'site_map': 'site_map',
    'slideshow_rounded_fill': 'slideshow_rounded_fill',
    'sports-score-rounded': 'sports_score_rounded',
    'step-done': 'step_done',
    'step-inprogress': 'step_inprogress',
    'step-pasfait': 'step_pasfait',
    'step_success': 'step_done',
    'student_add': 'check_circle_outline',
    'tile-small-rounded': 'tile_small_rounded',
    'timer': 'acute',
    'tips': 'tips',
    'toolbar__notification': 'notifications_rounded',
    'toolbar__unread-notification': 'notifications_unread_rounded',
    'tooltip-info': 'info',
    'trainer_add': 'add',
    'transition': 'transition',
    'trash': 'trash',
    'unarchive': 'desarchiver',
    'unassign': 'unassign',
    'unlock': 'unlock',
    'user-menu': 'arrow_drop_down_700',
    'view_carousel_rounded_fill': 'view_carousel_rounded_fill',
    'visibility': 'visibility',
    'visibility_cgurgpd': 'cgu',
    'visibility_legalnotice': 'visibility',
    'visibility_privacy': 'privacy',
    'wall_art_rounded_fill': 'wall_art_rounded_fill',
    'web': 'web',
    'workgroup_add': 'add',
    'world': 'world',
    'xxx': 'dislike',
};